module.exports = __webpack_public_path__ + "static/no-gelatin-9fee0698f73148049263a3550153bb56.png";